import React,{ useState, useEffect } from 'react';

import Fig1 from '../../images/hardware-setup/stb-setup-figure-one.png';
import Fig2 from '../../images/hardware-setup/stb-setup-figure-two.png';
import Fig3 from '../../images/hardware-setup/stb-setup-figure-three.png';
import Fig4 from '../../images/hardware-setup/stb-setup-figure-four.png';
import Fig5 from '../../images/hardware-setup/stb-setup-figure-five.png';

function STBSetup() {

    return (
        <div id="stb-setup-component" className="modem-setup-component modem-connectivity-component">
            <h2>How to Connect Your Set-Top Box</h2>
            <h4>Contents</h4>
            <div className='hardware-setup-text-image-row'>
                <div className='copy'>
                    <p>Your Amigo 7X is supplied with the correct power adapter for your region. Depending on the choices made by your service provider, your box may also contain the optional accessories shown below.<br/><br/>
                    The Amigo 7X is protected with a clear plastic film. This should be removed before use.</p>
                </div>
                <img src={ Fig1 } />
            </div>

            <h4>Accessories</h4>
            <div className='hardware-setup-text-image-row'>
                <div className='copy'>
                    <div className='copy-divider'>
                        <p className='copy-divider-label'>HDMI Cable</p>
                        <span className='divider'></span>
                    </div>
                    <div className='copy-divider'>
                        <p className='copy-divider-label'>Power Supply</p>
                        <span className='divider'></span>
                    </div>
                    <div className='copy-divider'>
                        <p className='copy-divider-label'>Remote Control and Batteries</p>
                        <span className='divider'></span>
                    </div>
                </div>
                <img src={ Fig2 } />
            </div>

            <h4>Overview</h4>
            <ol>
                <li>Power/Activity LED</li>
                <li>Infra Red receiver LED - lights when signal is received from the remote control</li>
                <li>Internet LED - lights when the product has internet connection.</li>
                <li>Analogue A/V output (adapter cable available).</li>
                <li>HDMI port.</li>
                <li>Ethernet port.</li>
                <li>DC power input 12V/1A PSU.</li>
                <li>2X USB port. DO NOT use this port to charge USB devices. It can be used to
                    access external storage media such as a USB flash drive if formatted as FAT32.These ports can also be used to update software and program lists on the Amigo 7X.
                </li>
            </ol>
            <img src={ Fig3 } />

            <div style={{ fontWeight:600, marginTop:'3rem', marginBottom:'1.5rem' }}>Connecting Your Set-Top Box to a TV</div>
            <img src={ Fig4 } />
            <div className='setup-steps-container'>
                <div className='step-item'>
                    <div style={{ fontWeight:600, marginTop:'2rem' }}>Before You Begin</div>
                    <p style={{ fontSize:'0.9rem' }}>Check your Start.ca email for your activation code.</p>
                </div>
                <div className='step-item'>
                    <div style={{ fontWeight:600, marginTop:'2rem' }}>Step 1</div>
                    <p style={{ fontSize:'0.9rem' }}>Connect the set-top box to your TV using the HDMI cable.</p>
                </div>
                <div className='step-item'>
                    <div style={{ fontWeight:600, marginTop:'2rem' }}>Step 2</div>
                    <p style={{ fontSize:'0.9rem' }}>Power the set-top box with the power cord.</p>
                </div>
                <div className='step-item'>
                    <div style={{ fontWeight:600, marginTop:'2rem' }}>Step 3</div>
                    <p style={{ fontSize:'0.9rem' }}>Press down on the Off/On button to turn on the set-top box.</p>
                </div>
            </div>
            <p style={{ fontSize:'0.9rem' }}><span style={{ fontWeight: 600 }}>Want a wired connection?</span> Connect the set-top box to your modem or router with the Ethernet cable</p>

            <h4>Connecting Your Set-Top Box to an A/V Amplifier</h4>
            <p style={{ fontSize:'0.9rem', marginBottom: '2.5rem' }}>Connect an HDMI cable to the HDMI output of the Amigo 7X and to the HDMI input of your A/V amplifier or home cinema system.</p>
            <img src={ Fig5 } />
        </div>
    )
}

export default STBSetup